import { Box } from '@mui/material'
import React from 'react'

const ReferralManagement = () => {
  return (
    <Box>ReferralManagement</Box>
  )
}

export default ReferralManagement